import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 345,
  },
  media: {
    height: 200,
    paddingTop: '56.25%', // 16:9
  },
}));

export default function Maps() {
  const classes = useStyles();
  return (
    <Card>
      <CardContent>
        예수님행적 지도(4복음서)
      </CardContent>
      <CardMedia
        className={classes.media}
        image="/images/map.jpg"
        title="Jesus map"
      />
    </Card>
  );
}
